// extracted by mini-css-extract-plugin
export var active = "PageNav_active__e7YAK";
export var arrow = "PageNav_arrow__VaMqH PageNav_pageButton__KYVeB";
export var buttonsContainer = "PageNav_buttonsContainer__oWS6J";
export var container = "PageNav_container__eA2j5";
export var nextInactive = "PageNav_nextInactive__CxUwm";
export var pageButton = "PageNav_pageButton__KYVeB";
export var pageNum = "PageNav_pageNum__HWJ6d";
export var prevInactive = "PageNav_prevInactive__YT+Zt";